import * as T from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const w = window as any;

export default w?.Shell?.v1?.store as T.StoreType;
